module.exports = __webpack_public_path__ + "img/m_tradebg.8d6aa482.jpg";